module.exports = __webpack_public_path__ + "img/img-lgpd.5865266d.svg";